export default __webpack_public_path__ + "static/media/logo-lg.1d06fd24.jpg";